(function($) {

	'use strict';

	var init = function() {
		initStickerToggle();
	}

	var initStickerToggle = function() {
		$('.sticker').click(function(){
      var $this = $(this);
      $this.toggleClass('active');
    });
	}

	$(document).ready(function() {
		init();
	});

})(jQuery);
